import { Divider, Radio, Row } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { Team } from "shared/interfaces/Team";
import { fetchLoggedUserTeams } from "shared/service/StrmService";
import TeamDetails from "./TeamDetails";
import TeamManagement from "./TeamManagement";
import TeamSubscription from "./TeamSubscription";

const TeamConfiguration: React.FC<RouteComponentProps> = (props) => {
  const { t } = useTranslation("radar");
  const [selectedTab, setSelectedTab] = useState<string>("details");
  const [loadingTeam, setLoadingTeam] = useState<boolean>(false);
  const [team, setTeam] = useState<Team>();

  const onChangeTab = (e: any) => {
    setSelectedTab(e.target.value);
  };

  const getTeams = async () => {
    setLoadingTeam(true);
    const response: any = await fetchLoggedUserTeams();
    setTeam(response);
    setLoadingTeam(false);
  };

  useEffect(() => {
    const localGetTeams = async () => {
      setLoadingTeam(true);
      const response: any = await fetchLoggedUserTeams();
      setTeam(response);
      setLoadingTeam(false);
    };
    localGetTeams();
  }, []);
  return (
    <div className="team-management">
      <Row>
        <Radio.Group onChange={onChangeTab} value={selectedTab}>
          <Radio.Button value="details">
            {t("pages.TeamManagement.details")}
          </Radio.Button>
          <Radio.Button value="subscription">
            {t("pages.TeamManagement.subscription")}
          </Radio.Button>
          <Radio.Button value="team">
            {t("pages.TeamManagement.team")}
          </Radio.Button>
        </Radio.Group>
      </Row>

      <Divider style={{ backgroundColor: "#1f1f1f" }} />
      {selectedTab === "details" && <TeamDetails team={team} />}
      {selectedTab === "subscription" && <TeamSubscription team={team} />}
      {selectedTab === "team" && (
        <TeamManagement
          loading={loadingTeam}
          team={team}
          getTeams={getTeams}
          setLoading={setLoadingTeam}
        />
      )}
    </div>
  );
};

export default TeamConfiguration;
